// extracted by mini-css-extract-plugin
export default {"container":"InfoButton_container__CCkrw"};